<script lang="ts">
	import { getFooter } from '$lib/api/footer';
	import { fly } from 'svelte/transition';
	import SocialBubble from './socialBubble.svelte';
	import MillStone from '$lib/icons/millStone.svelte';
	import GridContainer from '../../routes/(marketing)/order-now/gridContainer.svelte';
	import Grid from '../../routes/(marketing)/order-now/grid.svelte';
	import FooterLink from '$lib/buttons/footerLink.svelte';
	import { footerVisible } from '$lib/stores/footer';
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import SanityImage from '$lib/sanityImage.svelte';

	const footer = getFooter();

	const transition = { y: 100 };
	const currentYear = new Date().getFullYear();
</script>

<footer
	class="bg-white px-6 pb-6 pt-8 md:px-8 lg:pb-9 xl:px-12"
	use:checkVisibility={{ threshold: 0 }}
	onvisible={(e) => footerVisible.set(e.detail)}
>
	<GridContainer>
		{#await footer}
			<div class="h-80"></div>
		{:then content}
			<div class="mb-8 flex flex-wrap items-center gap-8 lg:hidden" in:fly={transition}>
				{#each content.socialIcons as icon}
					<SocialBubble url={icon.url}>
						<SanityImage
							assetId={icon.assetId}
							loading="lazy"
							alt={icon.alt || ''}
							class="h-full py-2"
							width="22"
							height="22"
						/>
					</SocialBubble>
				{/each}
			</div>
			<Grid margin={false} class="lg:mb-20">
				{#each content.linkCategories as category}
					<div in:fly={transition} class="col-span-4 max-lg:mb-8 lg:col-span-2">
						<div class="flex flex-col items-start gap-y-3">
							<strong class="text-[12px]/[100%] font-semibold uppercase text-green-2"
								>{category.title}</strong
							>
							{#each category.links as link}
								<FooterLink url={link.url} external={link.external} label={link.label} />
							{/each}
						</div>
					</div>
				{/each}

				<div class="col-span-2 flex flex-col gap-y-3 max-lg:hidden" in:fly={transition}>
					<strong class="text-[12px]/[100%] font-semibold uppercase text-green-2"
						>{content.socialTitle}</strong
					>
					<div class="flex gap-3">
						{#each content.socialIcons as icon}
							<SocialBubble url={icon.url}>
								<SanityImage
									dimensions={{ width: 64, height: 64 }}
									assetId={icon.assetId}
									loading="lazy"
									alt={icon.alt || ''}
									class="aspect-square"
									height="64"
									width="64"
								/>
							</SocialBubble>
						{/each}
					</div>
				</div>
			</Grid>
			<hr class="absolute inset-x-0 w-screen border-t border-t-stone-3 max-lg:hidden" />
			<Grid margin={false} class="lg:pt-9">
				<div
					in:fly={transition}
					class="col-span-4 mb-6 flex items-center justify-between text-[12px]/[120%] text-brown-3 lg:hidden"
				>
					{#each content.legalLinks as link}
						<a
							href={link.url}
							target={link.external ? '_blank' : null}
							rel={link.external ? 'noopener noreferrer' : null}>{link.label || link.url}</a
						>
					{/each}
				</div>
				<div
					class="flex flex-col justify-center gap-y-1 text-[12px]/[120%] text-brown-3 max-lg:col-span-4 lg:col-start-1 lg:col-end-6"
				>
					<p>Copyright © {currentYear} Mill Industries Inc.</p>
					<p>
						Mill, Mill Membership, Food Grounds, <MillStone class="inline h-3 w-3 align-top" /> , and
						related marks are trademarks of Mill.
					</p>
				</div>
				<div
					in:fly={transition}
					class="col-start-7 col-end-13 flex items-end justify-end gap-x-4 max-lg:hidden"
				>
					{#each content.legalLinks as link}
						<FooterLink
							variant="legal"
							url={link.url}
							external={link.external}
							label={link.label}
						/>
					{/each}
				</div>
			</Grid>
		{/await}
	</GridContainer>
</footer>
